import { Analyzer, AnalyzerPropertyConstants, SnapshotValidation } from 'types';
import { SnapshotTraceHistoryCombination } from 'features/analyzers/types';

import {
  MenuItem,
  InputLabel,
  Select,
  TextField,
  FormControl,
  FormHelperText,
} from '@mui/material';

import { formatFreqPretty } from 'utils/FreqUtils';

interface Props {
  analyzer: Analyzer | undefined;
  analyzerPropertyConstants: AnalyzerPropertyConstants;
  selectedSnapshot: SnapshotTraceHistoryCombination;
  editedSnapshot: SnapshotTraceHistoryCombination;
  validatedSnapshotProperties: SnapshotValidation | null | undefined;
  validatedPropertyErrors: any;
  editDisabled: boolean;
  disableErrorBox: boolean;
  handleChange: (e: any) => void;
}

const VbworAverageInput = ({
  analyzer,
  analyzerPropertyConstants,
  selectedSnapshot,
  editedSnapshot,
  validatedSnapshotProperties,
  validatedPropertyErrors,
  editDisabled,
  disableErrorBox,
  handleChange,
}: Props) => {
  const { type } = analyzer || {};

  //SED Decimator uses averages instead of a real VBW value
  if (type === 4) {
    return (
      <TextField
        variant='outlined'
        required
        fullWidth
        id='vbw'
        label='Average Amount'
        name='vbw'
        autoComplete='average_amount'
        size='small'
        type='number'
        inputProps={{
          min: '1',
          step: '1',
        }}
        value={Number(editedSnapshot.vbw) <= 0 ? '' : editedSnapshot.vbw}
        onChange={handleChange}
        disabled={!editedSnapshot?.id || editDisabled}
      />
    );
  }

  return (
    <FormControl
      variant='outlined'
      size='small'
      error={validatedPropertyErrors.vbwError && !disableErrorBox}
      fullWidth
    >
      <InputLabel id='vbw-label'>VBW</InputLabel>
      <Select
        labelId='vbw-label'
        id='vbw'
        name='vbw'
        label='vbw'
        required
        value={editedSnapshot?.vbw || ''}
        onChange={handleChange}
        disabled={!editedSnapshot?.id || editDisabled}
      >
        {analyzerPropertyConstants?.VBW_VALUES.map((value: string) => (
          <MenuItem value={value} key={value}>
            {value}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>
        {(validatedPropertyErrors.vbwError ||
          selectedSnapshot.vbw === 'AUTO') &&
          validatedSnapshotProperties &&
          formatFreqPretty(validatedSnapshotProperties?.vbw)}
      </FormHelperText>
    </FormControl>
  );
};

export default VbworAverageInput;
